import { AppState } from '../../types/store';

export const getCurrentPage = (state: AppState) => state.pageInfo.currentPage;
export const getTotalPages = (state: AppState) => state.pageInfo.totalPages;
export const getPageInfoStats = (state: AppState) => state.pageInfo.stats;
export const getBiMetadata = (state: AppState) => state.pageInfo.biMetadata;
export const getRequestParams = (state: AppState) =>
  state.pageInfo.requestParams;
